// Feito por Guilherme <https://guilhermerocha.dev.br>

document.addEventListener("scroll", (event) => {
  const scrollY = window.scrollY;
  const header = document.querySelector('header');
  
  if(header !== null){
      scrollY >= 120 ? header.classList.add("fixed") : header.classList.remove("fixed");
  }
})

(function moveCollectionDescriptionToBottom(){
  const mainContent = document.querySelector('.template-collection main#MainContent');
  const collectionDescription = document.querySelector('.template-collection #description-relative');
  
  if(mainContent !== null && collectionDescription !== null){
      mainContent.append(collectionDescription);
      collectionDescription.classList.remove('loading');
  }
}()) 